import { RouteEnum } from '@/layouts/routes/model/Route.model.ts';

export enum LocalStorageParam {
  LAST_VISITED_LOCATION = 'LAST_VISITED_LOCATION',
}
export type PathParams = { params: Record<string, string>; pathname: Path } | Path;
type Path = RouteEnum | string;

export const setLocalStorage = (key: LocalStorageParam, value: PathParams): void => {
  if (typeof value === 'object') {
    localStorage.setItem(key, value.pathname);
    return;
  }
  localStorage.setItem(key, value);
};

export const getLocalStorage = (key: LocalStorageParam): string | null => {
  return localStorage.getItem(key);
};
